import { render, staticRenderFns } from "./LastOrders.vue?vue&type=template&id=294ba68c&"
import script from "./LastOrders.vue?vue&type=script&lang=js&"
export * from "./LastOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294ba68c')) {
      api.createRecord('294ba68c', component.options)
    } else {
      api.reload('294ba68c', component.options)
    }
    module.hot.accept("./LastOrders.vue?vue&type=template&id=294ba68c&", function () {
      api.rerender('294ba68c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/LastOrders.vue"
export default component.exports